'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { useLiveValueTrajectory } from '@/hooks/chart/use-live-value-trajectory';
import type { MarketChartOutcome } from './market-chart';
export interface LiveTrajectoryPoint {
  readonly time: number;
  readonly value: number;
}
export interface LiveMarketCapTrajectories {
  readonly marketCap: Readonly<Record<number, ReadonlyArray<LiveTrajectoryPoint>>>;
}
interface LiveMarketCapTrajectoryBoundaryProps {
  readonly outcomes: ReadonlyArray<MarketChartOutcome>;
  readonly enabled: boolean;
  readonly windowSecs: number;
  readonly resetKey: string;
  readonly children: (trajectories: LiveMarketCapTrajectories) => ReactNode;
}
export function LiveMarketCapTrajectoryBoundary(t0) {
  const $ = _c(11);
  const {
    outcomes,
    enabled,
    windowSecs,
    resetKey,
    children
  } = t0;
  let t1;
  if ($[0] !== outcomes) {
    t1 = outcomes.flatMap(_temp);
    $[0] = outcomes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const samples = t1;
  let t2;
  if ($[2] !== enabled || $[3] !== resetKey || $[4] !== samples || $[5] !== windowSecs) {
    t2 = {
      samples,
      enabled,
      windowSecs,
      resetKey
    };
    $[2] = enabled;
    $[3] = resetKey;
    $[4] = samples;
    $[5] = windowSecs;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const trajectory = useLiveValueTrajectory(t2);
  let t3;
  if ($[7] !== children || $[8] !== outcomes || $[9] !== trajectory) {
    const marketCap = {};
    for (const outcome_0 of outcomes) {
      marketCap[outcome_0.index] = trajectory[outcome_0.index] ?? [];
    }
    t3 = children({
      marketCap
    });
    $[7] = children;
    $[8] = outcomes;
    $[9] = trajectory;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(outcome) {
  return Number.isFinite(outcome.marketCap) && outcome.marketCap > 0 ? [{
    index: outcome.index,
    value: outcome.marketCap
  }] : [];
}